import React, { useState } from 'react';
import '../App.css';
import { useLocation } from 'react-router-dom';
import { Form, FormGroup, Button, Input } from 'reactstrap';
import MyLoader from './util/loader';
import MyStorage from './util/storage';
import Api from './api/api';
import showToast from './util/toast';
import { ToastContainer } from 'react-toastify';
import MyPopup from './util/popup';

const SendNotification = () => {
    const location = useLocation()

    let user_id = ''
    if (location.state) {
        if (location.state.user) {
            if (location.state.user != null) {
                user_id = location.state.user.id
            }
        }
    }

    const [recepients, setRecepients] = useState(user_id);
    const [sendToAll, setSendToAll] = useState(false);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [loader, setLoader] = useState(false);

    const sendNotification = () => {
        if (!sendToAll && recepients === '') {
            showToast('error', 'Please select recepients!')
            return
        }
        if (title === '') {
            showToast('error', 'Please enter title!')
            return
        }
        if (body === '') {
            showToast('error', 'Please enter body!')
            return
        }

        setLoader(true);
        Api.sendNotification(sendToAll ? 'all' : recepients, title, body,
            (response) => {
                setLoader(false);
                if (response.status === 'success') {
                    showToast('success', 'Notification Sent!')
                    // history.goBack()
                }
            },
            (error) => {
                setLoader(false);
                showToast('error', '' + error)
            });
    };

    return (
        <div className='main'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Send Push Notification
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: 15 }}>
                <Form className="form" style={{ width: 600, marginTop: 20, backgroundColor: '#f2f2f2' }}>
                    <FormGroup style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={sendToAll}
                                onChange={() => {
                                    setSendToAll(!sendToAll)
                                }}
                            />
                            <div style={{ marginLeft: 10 }}>
                                Send to all
                            </div>
                        </div>
                    </FormGroup>
                    {sendToAll ?
                        null
                        :
                        <FormGroup style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                            <Input
                                type='text'
                                placeholder='User IDs (comma separated)'
                                value={recepients}
                                onChange={(event) => {
                                    setRecepients(event.target.value)
                                }} />
                            <MyPopup
                                collect='id'
                                title={'Select Users'}
                                models={MyStorage.getAllUsers()}
                                onDone={(users) => { // label, value (email)
                                    console.log('selected: ' + JSON.stringify(users));
                                    let ids = ''
                                    for (let i = 0; i < users.length; i++) {
                                        const user = users[i];
                                        if (i < users.length - 1)
                                            ids = ids + user.value + ','
                                        else
                                            ids = ids + user.value
                                    }
                                    setRecepients(ids)
                                }}
                                button={
                                    <Button
                                        style={{ marginLeft: 10, fontSize: 16 }}
                                        className='btn-block btn-dark'
                                        onClick={() => {
                                            //
                                        }}>
                                        Choose
                                    </Button>
                                } />
                        </FormGroup>
                    }

                    <FormGroup style={{ marginTop: 10 }}>
                        <Input
                            type='text'
                            placeholder='Notification Title'
                            value={title}
                            onChange={(event) => {
                                setTitle(event.target.value)
                            }} />
                    </FormGroup>
                    <FormGroup style={{ marginTop: 10 }}>
                        <Input
                            type='textarea'
                            placeholder='Notification Body'
                            value={body}
                            onChange={(event) => {
                                setBody(event.target.value)
                            }} />
                    </FormGroup>
                    <Button
                        style={{ marginTop: 20 , fontSize: 16}}
                        className='btn-block btn-dark'
                        onClick={() => {
                            sendNotification()
                        }}>
                        Send Notification
                    </Button>
                </Form>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default SendNotification;